var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloudDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18 19v-2a3 3 0 000-6h-.063l-.863.018-.143-.852a5.002 5.002 0 00-9.265-1.662l-.275.478-.551.021A4 4 0 006 16.874v2.043A6.002 6.002 0 016.22 7.05a7.004 7.004 0 0112.506 2.002A5.001 5.001 0 0118 19zm-7-.747V12h2v6.253l2.293-2.244 1.414 1.384L12 22l-4.707-4.607 1.414-1.384L11 18.253z"
  })));
}

export default SvgCloudDownload;